{
    "weekDaysSelector": {
        "0": "DO",
        "1": "LU",
        "2": "MA",
        "3": "MI",
        "4": "JU",
        "5": "VI",
        "6": "SA"
    },
    "sessionsForm": {
        "template": "Aforo del recinto",
        "capacity": "Aforo Abonoteatro",
        "soldTickets": "Entradas vendidas",
        "ticket": "PVP del evento",
        "ticketSubscription": "PVP Abonado",
        "accompanyingTicketPrice": "PVP Acompañante",
        "subscriberCosts": "Gastos abonado",
        "accompanyingCosts": "Gastos Acomp."
    },
    "eventSessionFinishSelector": {
        "sessionFinishByAction": "Cierre de sesión según acción",
        "sessionFinishAt": "Cierre de sesión según hora"
    }
}
